// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"c90fc823","453":"7678b397","777":"f8bc9202"}[chunkId] + ".chunk.js";
};